/* © 2018-2022 TakuLabs Ltd. All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential */

import { Injectable } from "@angular/core";
import { DBService } from "../../../shared/services/db.service";
import { DataType, FilterType, Col } from "../../../form-list/form-list/form-list";
import { UOfMeasure_type } from "./u-of-measure";
import { FormListModel } from "../../../form-list/form-list/form-list-model.interface";
import { ValidatorFn, Validators } from "@angular/forms";

@Injectable({
  providedIn: "root",
})
export class UnitOfMeasureService extends DBService implements FormListModel {
  enum_measure_type = this.enumSelectOptions(UOfMeasure_type);

  getValidationRules(): { [key: string]: ValidatorFn[] | {} } {
    return {
      type: [Validators.required],
      name: [Validators.required],
    };
  }

  getFormListColumns() {
    return [
      {
        field: "isEnabled",
        header: "Is Enabled",
        visible: true,
        readonly: false,
        frozen: false,
        dataType: DataType.checkbox,
        dataOptions: Col.boolean_filter_enum,
        filterType: FilterType.enum,
      },
      {
        field: "name",
        header: "Description",
        visible: true,
        readonly: false,
        frozen: false,
        dataType: DataType.input,
        dataOptions: [],
        filterType: FilterType.contains,
      },
      {
        field: "type",
        header: "Measure Type",
        visible: true,
        readonly: false,
        frozen: false,
        dataType: DataType.enum,
        dataOptions: this.enum_measure_type,
        filterType: FilterType.enum,
      },
    ];
  }
}

/* © 2018-2022 TakuLabs Ltd. All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential */
